var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_6224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0516 0H26.3449L16.9651 11.0135L28 26H19.3595L12.5924 16.9105L4.84909 26H0.552836L10.5855 14.22L0 0H8.85932L14.9764 8.30788L22.0516 0ZM20.5446 23.3599H22.9238L7.56673 2.50152H5.01391L20.5446 23.3599Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_6224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 26,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewX);
export default __webpack_public_path__ + "static/media/newX.4e53191f1d6e8e7c476c300aca69f5de.svg";
export { ForwardRef as ReactComponent };